import { useEffect } from 'react';
import { BrowserTracing } from '@sentry/tracing';

export const useLogs = () => {
  useEffect(() => {
    if (!window.Sentry) {
      import('@sentry/react').then((Sentry) => {
        if (window.location.hostname !== 'getstream.io') {
          // eslint-disable-next-line no-console
          console.info('Sentry reporting is disabled for this env.');
          return;
        }

        Sentry.init({
          environment: process.env.NODE_ENV || 'development',
          dsn:
            import.meta.env.VITE_SENTRY_DSN ||
            'https://cfe9b30508b44e40908da83aee0743e9@o389650.ingest.sentry.io/5556314',
          autoSessionTracking: true,
          integrations: [new BrowserTracing()],
          ignoreErrors: ['ChunkLoadError'],
        });

        window.Sentry = Sentry;
      });
    }
  }, []);
};
